import { Facebook, Twitter, Youtube, Email, Phone } from './icons';

export const links = [
  {
    url: 'https://www.facebook.com/NorthlandFdn',
    Icon: Facebook,
    newTab: true,
    noBackground: true,
  },
  { url: 'https://twitter.com/northlandfdn', Icon: Twitter, newTab: true },
  {
    url: 'https://www.youtube.com/channel/UCPdy6N0vwChJyzDHHmHs1Ew',
    Icon: Youtube,
    newTab: true,
  },
  { url: 'mailto:info@northlandfdn.org', Icon: Email },
  { url: 'tel:218-723-4040', Icon: Phone },
];

export const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer__blurb">
        <div className="footer__inner">
          <p>
            From traditional, ancestral & contemporary lands of Ojibwe, Dakota,
            Northern Cheyenne & other Native people. See a more{' '}
            <a
              target="_blank"
              href="https://northlandfdn.org/special-initiatives/maada-ookiing-land-acknowledgement.php"
            >
              detailed acknowledgement
            </a>{' '}
            of this land and its history.
          </p>
        </div>
      </div>
      <div className="footer__cta">
        <div className="footer__inner">
          <h2>Support Our Mission</h2>
          <a href="https://northlandfdn.org/make-a-gift/donate-online.php" target="_blank" className="button">Donate</a>
        </div>
      </div>
      <nav className="footer__nav">
        <div className="footer__inner">
          <span>
            © {new Date().getFullYear()}{' '}
            <a href="https://northlandfdn.org">Northland Foundation</a>
          </span>
          <ul className="footer__menu">
            {links.map(({ url, Icon, newTab, noBackground }) => (
              <li key={url} className="footer__menu-item">
                <a
                  className={noBackground && 'no-background'}
                  href={url}
                  {...(newTab && {
                    target: '_blank',
                    rel: 'noopener noreferrer',
                  })}
                >
                  <Icon />
                </a>
              </li>
            ))}
          </ul>
        </div>
      </nav>
    </footer>
  );
};
